import React from "react";
import { SdfMultiSelect } from '@synerg/react-components';
import "./AllMultiSelect.scss";

/**
 * @param {Array<{ group?: Array }>} items
 */
const reduceItemList = (items) => items.reduce((acc, item) => {
  if (item.group) {
    acc.push(...item.items);
  } else {
    acc.push(item);
  }
  return acc;
}, []);

const AllMultiSelect = ({ items, value, onSdfChange, ...rest }) => {
  const all = { label: "All", value: "All" };
  const reducedItems = reduceItemList(items);

  const initialAll = items.length > 0 && value.length === reducedItems.length;
  const allItems =  items.length > 0 ? [all, ...items] : items;
  const allValues = initialAll ? [...value, all] : value;

  const allOnSdfChange = (event) => {
    const changeAll = event.detail.find(({ value }) => value === "All");
    if (initialAll) {
      if (changeAll) {
        onSdfChange({ detail: event.detail.filter(({ value }) => value !== "All")});
      } else {
        onSdfChange({ detail: [] });
      }
    } else {
      if (changeAll) {
        onSdfChange({ detail: reducedItems.map(({ label, value }) => ({ label, value })) });
      } else {
        onSdfChange(event);
      }
    }
  };

  return <SdfMultiSelect items={allItems} value={allValues} onSdfChange={allOnSdfChange} {...rest} />;
};

export default AllMultiSelect;
export { reduceItemList };
